(() => {
  const rootPath = window.Shopify?.routes?.root || '/';

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-quick-add]');
    if (!button || button.disabled) return;
    const original = button.textContent;
    const feedback = button.closest('.pp-product-card__content')?.querySelector('[data-card-feedback]');
    button.disabled = true;
    button.textContent = 'Aggiungo…';
    if (feedback) feedback.textContent = '';
    try {
      const body = new FormData();
      body.append('id', button.dataset.variantId);
      body.append('quantity', '1');
      const response = await fetch(rootPath + 'cart/add.js', { method: 'POST', body, headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Non è stato possibile aggiungere il prodotto.');
      button.textContent = 'Aggiunto ✓';
      if (feedback) feedback.textContent = 'Prodotto aggiunto al carrello.';
      document.dispatchEvent(new CustomEvent('pp:cart-added'));
      setTimeout(() => { button.textContent = original; button.disabled = false; }, 1500);
    } catch (error) {
      button.textContent = original;
      button.disabled = false;
      if (feedback) feedback.textContent = error.message;
    }
  });

  document.querySelectorAll('[data-product-recommendations]').forEach(async (section) => {
    const productId = section.dataset.productId;
    const sectionId = section.dataset.sectionId;
    const limit = section.dataset.limit || '4';
    if (!productId || !sectionId) return;
    try {
      const url = `${rootPath}recommendations/products?product_id=${encodeURIComponent(productId)}&limit=${encodeURIComponent(limit)}&section_id=${encodeURIComponent(sectionId)}`;
      const response = await fetch(url, { headers: { Accept: 'text/html' } });
      if (!response.ok) return;
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const replacement = doc.querySelector('[data-product-recommendations]');
      if (replacement && replacement.querySelector('.pp-product-card')) section.replaceWith(replacement);
    } catch (e) {}
  });
})();
